import React, { useState, useRef, useEffect } from 'react';
import { FormControl, TextField, Button, IconButton, makeStyles, Box, Typography, Input, List, ListItem, ListItemIcon, ListItemText, Divider } from '@material-ui/core';
import { AttachFile as AttachFileIcon } from '@material-ui/icons';
import './support.scss';
import { useDispatch, useSelector } from "react-redux";
import { saveFeedbackForm } from 'examsbook-react-sdk/actions/saveFeedback';
import { useTranslations } from 'examsbook-react-sdk/custom-hooks';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import Select from 'react-select';
import OverlayButton from '../../constants/OverlayButton';
import { useTheme } from '../../constants/themeProvider';
import { ReactComponent as CameraIcon } from "../../assets/images/cameraIcon.svg";
import { ReactComponent as GalleryIcon } from "../../assets/images/galleryIcon.svg";
import { ColorsConstant } from '../../constants/colorConstant';

const useStyles = makeStyles(() => ({
    submitButton: {
        textTransform: 'capitalize',
        display: 'block',
        color: '#fff',
        marginBottom: '10px',
        borderRadius: '5px',
        '&:hover': {
            background: '#0c3450e0 !important'
        }
    },
    notification: {
        right: '20px',
        padding: '10px',
        position: 'fixed',
        top: '76px',
        zIndex: '1',
        backgroundColor: 'green',
        color: 'white',
        borderRadius: '20px',
        width: '300px',
        textAlign: 'center',
        fontWeight: '600'
    },
    buttonDisabled: {
        opacity: "0.4",
        cursor: "not-allowed",
    },
    attachmentModal: {
        position: 'absolute',
        top: '44px',
        left: 0,
        background: 'white',
        boxShadow: `3px 3px 10px ${ColorsConstant.boxShadow}`,
        borderRadius: 4,
        zIndex: 10
    },
    listText: {
        '& span': {
            fontSize: '14px'
        }
    },
    fullwidth: {
        width: '100%'
    }
}));

const Support = () => {
    /**Getting the user data from redux.. */
    const user = useSelector((state) => state.user);

    const [selectedDepartment, setSelectedDepartment] = useState('');
    const [selectedService, setSelectedService] = useState('');
    const [subject, setSubject] = useState('');
    const [others, setOthers] = useState('');
    const [email, setEmail] = useState(
        user?.user?.email ? user?.user?.email : user?.email
    );
    const [message, setMessage] = useState('');
    const [selectedFile, setSelectedFile] = useState(null);
    const fileInputRef = useRef(null);
    const dispatch = useDispatch();
    const t = useTranslations();
    const theme = useTheme();
    const history = useHistory();
    const [isOthersSelected, setIsOthersSelected] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);
    const [serviceOptions, setServiceOptions] = useState([]);
    const classes = useStyles();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isDepartmentVisible, setIsDepartmentVisible] = useState(false);
    const [isSubjectVisible, setIsSubjectVisible] = useState(false);
    const [isEmailVisible, setIsEmailVisible] = useState(false);
    const [isMessageVisible, setIsMessageVisible] = useState(false);
    const [isServiceVisible, setIsServiceVisible] = useState(false);
    const [isOthersVisible, setIsOthersVisible] = useState(false);
    const [showNotification, setShowNotification] = useState(false);
    const [selectedFileName, setSelectedFileName] = useState(null);
    const [fileExtensionError, setFileExtensionError] = useState(false);
    const [fileExtension, setFileExtension] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [captureMode, setCaptureMode] = useState('file');
    const modalRef = useRef(null); 

    const options = [
        { value: 'support', label: t('Support') },
        { value: 'billing', label: t('Billing') },
        { value: 'technical', label: t('Technical') },
    ];

    const handleChange = (option) => {
        setSelectedOption(option);
        handleDepartmentChange(option);
    };

    // Function to handle closing modal when clicked outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                setIsModalOpen(false);  // Close modal when clicked outside
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleDepartmentChange = (option) => {
        setSelectedOption(option);
        setSelectedService(null);
        setIsOthersSelected(false);
        let services = [];
        if (option.value === 'support') {
            services = [t('Assessment Support'), t('Account Management'), t('Billing and Payment'), t('Content Support'), t('Course Enrollment'), t('General Enquiry'), t('Others')];
            setSelectedDepartment(option.value);
            setIsDepartmentVisible(false);
        } else if (option.value === 'billing') {
            services = [t('Billing Inquiries'), t('Invoice Request'), t('Payment Issue'), t('Refund Request'), t('Others')];
            setSelectedDepartment(option.value);
            setIsDepartmentVisible(false);
        } else if (option.value === 'technical') {
            services = [t('Course material Access'), t('Integration Support'), t('Login Issue'), t('Software Update'), t('System Error'), t('Others')];
            setSelectedDepartment(option.value);
            setIsDepartmentVisible(false);
        }
        setServiceOptions(services.map(service => ({ value: service, label: t(service) })));
    };

    const handleServiceChange = (option) => {
        setSelectedService(option);
        setIsOthersSelected(option.value === 'Others' || option.value === 'अन्य');
        setIsServiceVisible(false);
    };

    const handleInputChange = (event, setter, maxLength, errorSetter) => {
        if (event.target.value.length <= maxLength) {
            setter(event.target.value);
            if (errorSetter) {
                errorSetter(false);
            }
        }
    };
    
    const validateFile = (file) => file.size < 5 * 1024 * 1024;
    
    const validateEmail = (email) => {
        const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return regex.test(email);
    };

    const handleFileIconClick = () => {
        // For mobile devices: prompt camera or file picker
        if(/Android|iPhone|iPad/i.test(navigator.userAgent)) {
            setIsModalOpen(true); // Show modal for camera or file
        } else {
            // For desktop devices: open file picker
            fileInputRef.current.click();
        }
    };

    const handleCaptureSelect = (mode) => {
        setCaptureMode(mode);
        setIsModalOpen(false);
        if (mode === 'camera') {
            fileInputRef.current.capture = 'environment';
        } else {
            fileInputRef.current.removeAttribute('capture');
        }
        fileInputRef.current.click();
    };

    const handleFileChange = (event) => {
        setIsModalVisible(false);
        setFileExtensionError(false);
        
        const file = event.target.files[0];
        
        if(!file) {
            return;
        }
        
        const allowedExtensions = ['.jpeg', '.jpg', '.gif', '.png', '.pdf'];
        const ext = file?.name?.substring(file?.name?.lastIndexOf('.'));

        if (!allowedExtensions.includes(ext?.toLowerCase())) {
            setFileExtensionError(true);
            setSelectedFile(null);
            setSelectedFileName(null);
            return;
        } else if (!validateFile(file)) {
            setIsModalVisible(true);
            setSelectedFile(null);
            setSelectedFileName(null);
            return;
        }
        const reader = new FileReader();
        reader.onload = () => {
            setSelectedFile(reader.result);
            setSelectedFileName(file.name);
        }
        reader.readAsDataURL(file);
        setIsModalVisible(false);
        setFileExtensionError(false);
        setFileExtension(ext?.toLowerCase()); 
    };

    const handleBack = () => {
        history.goBack();
    };

    const handleSubmit = () => {
        let data = {
            department: selectedDepartment,
            subject: subject,
            email: email,
            message: message,
            service: selectedService?.value,
            file: selectedFile,
            serviceMessage: isOthersSelected ? others : ''
        }
        if (data.department && data.subject && data.message && data.service && validateEmail(email) && (!isOthersSelected || (isOthersSelected && data.serviceMessage))) {
            dispatch(saveFeedbackForm(data));
            setShowNotification(true);
            setTimeout(() => {
                setShowNotification(false);
                history.push('/support-ticket');
                setIsSubmitting(false);
            }, 2000);
        }

        if (!data.department) {
            setIsDepartmentVisible(true);
        }

        if (!data.subject) {
            setIsSubjectVisible(true);
        }

        if (!validateEmail(email)) {
            setIsEmailVisible(true);
        }

        if (!data.message) {
            setIsMessageVisible(true);
        }

        if (!data.service) {
            setIsServiceVisible(true);
        }

        if (isOthersSelected && !data.serviceMessage.length) {
            setIsOthersVisible(true);
            setIsSubmitting(false);
        }

    };

    return (
        <Box className="support-container">
            <Box className="support-ticket-box commonShadow">
            {showNotification && (
                <Box className={classes.notification}>
                    {t('Support ticket created successfully!')}
                </Box>
            )}
                <Box className='description'>
                {t('Provide ticket details below. When reporting a problem make sure to provide as much relevant information as possible.')}
                </Box>
                <Box className='form-box'>
                    <Typography component="label" className='form-label' style={{color: theme?.secondaryColor}}>{t('Category')}</Typography><Typography component="label" className='red-star'> *</Typography>
                    <FormControl className={classes.fullwidth}>
                        <Select 
                        labelId="department-label"
                        placeholder={t('SelectCategory')}
                        id="department"
                        value={selectedOption}
                        onChange={handleChange}
                        options={options}
                        styles={{
                            option: (provided) => ({
                            ...provided,
                            fontWeight: '400'
                            }),
                        }}
                        />
                    </FormControl>
                    {selectedOption && (
                        <Box>{`Queries related to ${selectedOption.label} (Issues, Suggestion, Questions)`}</Box>
                    )}
                    {isDepartmentVisible && <Typography variant="inherit" className='validation-text'>
                        {t('SelectTheCategory')}
                    </Typography>}
                </Box>
                <Box className='form-box'>
                    <Typography component="label" className='form-label' style={{color: theme?.secondaryColor}}>{t('Select the related service')}</Typography><Typography component="label" className='red-star'> *</Typography>
                    <FormControl className={classes.fullwidth}>
                        <Select 
                            labelId="service-label"
                            id="service"
                            placeholder={t('selectService')}
                            value={selectedService}
                            onChange={handleServiceChange}
                            options={serviceOptions}
                            styles={{
                                option: (provided) => ({
                                    ...provided,
                                    fontWeight: '400',
                                }), 
                                menu: (provided) => ({
                                    ...provided,
                                    overflow: 'auto',
                                    maxHeight: 160,
                                })
                            }}
                        />
                    </FormControl>
                    {isServiceVisible && <Typography variant="inherit" className='validation-text'>
                        {t('Choose Service')}
                    </Typography>}
                </Box>
                {isOthersSelected && (
                    <Box className='form-box'>
                        <Typography component="label" className='form-label' style={{color: theme?.secondaryColor}}>{t('Please provide more details')}</Typography><Typography component="label" className='red-star'> *</Typography>
                        <TextField
                            id="others"
                            placeholder='Enter more details'
                            multiline
                            minRows={6}
                            className="message-input"
                            value={others}
                            onChange={(event) => handleInputChange(event, setOthers, 250, setIsOthersVisible)}
                        />
                        {isOthersSelected && isOthersVisible && <p className='validation-text'>
                        {t('Enter more details')}
                    </p>}
                    </Box>
                )}
                <Box className='form-box'>
                    <Typography component="label" className='form-label' style={{color: theme?.secondaryColor}}>{t('Subject')}</Typography><Typography component="label" className='red-star'> *</Typography>
                    <TextField
                        id="subject"
                        placeholder={t('Enter Subject')}
                        className="subject-input"
                        value={subject}
                        onChange={(event) => handleInputChange(event, setSubject, 50, setIsSubjectVisible)}
                    />
                    {isSubjectVisible && <Typography variant="inherit" className='validation-text'>
                        {t('Enter Subject')}
                    </Typography>}
                </Box>
                <Box className='form-box'>
                    <Typography component="label" className='form-label' style={{color: theme?.secondaryColor}}>{t('Email')}</Typography><Typography component="label" className='red-star'> *</Typography>
                    <TextField
                        id="email"
                        placeholder={t('Enter Email')}
                        className="subject-input"
                        value={email}
                        onChange={(event) => handleInputChange(event, setEmail, 50, setIsEmailVisible)}
                        InputProps={{
                            readOnly: true,
                        }}
                    />
                    {isEmailVisible && <Typography variant="inherit" className='validation-text'>
                        {t('Enter valid Email')}
                    </Typography>}
                </Box>
                <Box className='form-box'>
                    <Typography component="label" className='form-label' style={{color: theme?.secondaryColor}}>{t('Message')}</Typography><Typography component="label" className='red-star'> *</Typography>
                    <TextField
                        id="message"
                        placeholder={t('Enter Message')}
                        multiline
                        minRows={6}
                        className="message-input"
                        value={message}
                        onChange={(event) => handleInputChange(event, setMessage, 250, setIsMessageVisible)}
                    />
                    {isMessageVisible && <Typography variant="inherit" className='validation-text'>
                        {t('Enter Message')}
                    </Typography>}
                </Box>
            </Box>
            <Box className="support-service-box support-ticket-box commonShadow">
                <Box className='service-title'>{t('Concerned Service')}</Box>
                
                <Box>
                <Typography component="label" className='form-label' style={{color: theme?.secondaryColor}}>{t('Upload File')}</Typography>
                <Box className="attachment-section" position="relative">
                    <Input
                        id="selectedAttachment"
                        inputRef={fileInputRef}
                        type="file"
                        accept=".jpeg, .jpg, .gif, .png, .pdf"
                        capture={captureMode === 'camera' ? 'environment' : undefined}
                        style={{ display: 'none' }}
                        onChange={handleFileChange}
                    />
                    <IconButton onClick={handleFileIconClick} className="attachment-icon" component="label">
                        <AttachFileIcon />
                    </IconButton>
                    {isModalOpen && (
                        <Box ref={modalRef} className={classes.attachmentModal}>
                            <List>
                                <ListItem button onClick={() => handleCaptureSelect('file')}>
                                    <ListItemIcon style={{minWidth: '30px'}}>
                                        <GalleryIcon/>
                                    </ListItemIcon>
                                    <ListItemText primary="Photo Library" className={classes.listText}/>
                                </ListItem>
                                <Divider/>
                                <ListItem button onClick={() => handleCaptureSelect('camera')}>
                                    <ListItemIcon style={{minWidth: '30px'}}>
                                    <CameraIcon/>
                                    </ListItemIcon>
                                    <ListItemText primary="Take Photo" className={classes.listText}/>
                                </ListItem>
                            </List>
                        </Box>
                    )}
                    {selectedFileName && (
                        <Box>{`Attached file: ${selectedFileName}`} &nbsp;</Box>
                    )}
                    <Box className="attachment-message">{t('Allowed files')}: .jpeg, .jpg, .pdf, .png, .gif</Box>
                    <Box className="file-size">{t('Max 5 MB')}</Box>
                </Box>
                {selectedFile && fileExtension !== '.pdf' && (
                    <Box component="img" src={selectedFile} alt="Preview" style={{maxWidth: '100%', maxHeight: '200px'}} />
                )}
                </Box>
                {selectedFile && fileExtension === '.pdf' && (
                    <object data={selectedFile} type="application/pdf" style={{ maxWidth: '100%', maxHeight: '200px' }}>
                        <embed src={selectedFile} type="application/pdf" />
                    </object>
                )}
               {isModalVisible && <Typography variant="inherit" className='file-size'>
                    {t('File is too large!')}
                </Typography>}

                {fileExtensionError && <p className='file-size'>{t('You cannot upload this type of file!')}</p>}
            </Box>
            <Box className='submit-button'>
                <Button variant="outlined" onClick={handleBack} className='back-btn'>
                {t('Back')}
                </Button>
                <OverlayButton onClick={handleSubmit} title={t('Submit')} classStyleHeading={!fileExtensionError && !isModalVisible ? classes.submitButton : classes.submitButton + " " + classes.buttonDisabled} disabled={isSubmitting || fileExtensionError || isModalVisible}/>
            </Box>
        </Box>

    );
}

export default Support;